import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { getReactComponentName } from '@lacele/utils'
import actionTarget from '../../Redux/actionTarget'
import { formFieldsValue, formSubmit } from '../../FormReducer/action'
import { mapStateToProps } from './selector'

export default () => (Component) => {

    class Wrapper extends React.Component {

        constructor(props) {
            super(props)
            this.getRowId = this.getRowId.bind(this)
            this.onValidate = this.onValidate.bind(this)
            this.onSubmit = this.onSubmit.bind(this)
        }

        onValidate(name, value, valueMap) {
            const dataMap = this.getDataMap(this.props, value, valueMap)
            const {
                dispatch,
                storeTarget,
                onValidate
            } = this.props
            dispatch(actionTarget(formFieldsValue(dataMap), storeTarget))
            if (onValidate) {
                onValidate(name, value, valueMap)
            }
        }

        onSubmit() {
            const {
                dispatch,
                storeTarget,
                onSubmit
            } = this.props
            dispatch(actionTarget(formSubmit(), storeTarget))
            if (onSubmit) {
                onSubmit()
            }
        }

        getRowId() {
            const {
                rowId
            } = this.props
            return rowId
        }

        getDataMap({
            name,
            nameMap
        }, value, valueMap) {
            return nameMap ? valueMap : {
                [name]: value
            }
        }

        render() {
            const {
                onValidate,
                onSubmit,
                ...props
            } = this.props
            return (
                <Component
                    {...props}
                    onValidate={this.onValidate}
                    onSubmit={this.onSubmit}
                />
            )
        }
    }

    hoistNonReactStatic(Wrapper, Component)
    const Hoc = compose(
        connect(mapStateToProps)
    )(Wrapper)

    hoistNonReactStatic(Hoc, Wrapper)
    Hoc.displayName = `withState(${getReactComponentName(Component)})`

    return Hoc
}
